import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue-demi';
import { CdnImg, useCdnImg } from '@webplatform/cdn-image';
import useCategoryBanner from '../../../../composables/useCategoryBanner';
import useGsap from '../../../../composables/useGsap';
import { AbContainer, AbTitle, AbDescription } from '../../../ui';
import UiButton from '../../../canyon/ui/UiButton.vue';
import { CategoryBannerData } from '../../../../types';

interface Props {
  data: CategoryBannerData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionCarouselButtonItem',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: CategoryBannerData;
};


const { gsap, ScrollTrigger } = useGsap();

const { buttonColor } = useCategoryBanner({
  color: props.data.color,
  accentColor: props.data.accentColor,
});

const banner = ref(null);

const { generateUrl } = useCdnImg();

const animateOnScroll = () => {
  const space = 50;
  const content: any = banner.value;
  if (gsap && ScrollTrigger) {
    const imageBoxes = content.querySelectorAll('.image-box');
    imageBoxes.forEach((imageBox: any) => {
      gsap.fromTo(
        imageBox,
        {
          y: space,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: content,
            start: 'top center',
            end: '50% center',
            toggleActions: 'restart none none reverse',
          },
        },
      );

      gsap.fromTo(
        imageBox,
        {
          y: 0,
          opacity: 1,
        },
        {
          y: -space,
          opacity: 0,
          ease: 'power2.in',
          scrollTrigger: {
            trigger: content,
            start: 'bottom center',
            end: 'center top',
            toggleActions: 'restart none none reverse',
          },
        },
      );
    });

    const boxes = content.querySelectorAll('.box');
    boxes.forEach((box: any) => {
      gsap.fromTo(
        box,
        {
          y: space,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: content,
            start: 'top center',
            end: '50% center',
            toggleActions: 'restart none none reverse',
          },
        },
      );

      gsap.fromTo(
        box,
        {
          y: 0,
          opacity: 1,
        },
        {
          y: -space,
          opacity: 0,
          ease: 'power2.in',
          scrollTrigger: {
            trigger: content,
            start: 'bottom center',
            end: 'center top',
            toggleActions: 'restart none none reverse',
          },
        },
      );
    });

    gsap.fromTo(
      content.querySelector('.image'),
      {
        x: space,
        opacity: 0,
      },
      {
        x: 0,
        opacity: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: content,
          start: 'top center',
          end: '50% center',
          toggleActions: 'restart none none reverse',
        },
      },
    );
  }
};

onMounted(() => {
  animateOnScroll();
});

return { __sfc: true,props, gsap, ScrollTrigger, buttonColor, banner, generateUrl, animateOnScroll, CdnImg, AbContainer, AbTitle, AbDescription, UiButton }
}

})